module.exports = __webpack_public_path__ + "static/media/daroon_logo.237dc3ec.png";